import * as t from 'io-ts';
import { timestampCodec } from '../../validation/codecs';
import { CallResponseSchema } from '../common/callResponseSchema';

// SQL Record
export const ReleaseNoteRecordSchema = t.type({
    id: t.number,
    created_at: timestampCodec,
    version: t.string,
    description: t.string,
    release_date: t.union([timestampCodec, t.null]),
    published: t.boolean
});
export type ReleaseNoteRecord = t.TypeOf<typeof ReleaseNoteRecordSchema>;

// Create
export const CreateReleaseNoteSchema = t.intersection([
    t.type({
        version: t.string,
        description: t.string,
    }),
    t.partial({
        release_date: t.union([t.string, t.null]),
        published: t.boolean
    })
]);
export type CreateReleaseNote = t.TypeOf<typeof CreateReleaseNoteSchema>;

// Update
export const UpdateReleaseNoteSchema = t.intersection([
    t.type({
        id: t.number,
    }),
    t.partial({
        version: t.string,
        description: t.string,
        release_date: t.union([t.string, t.null]),
        published: t.boolean
    })
]);
export type UpdateReleaseNote = t.TypeOf<typeof UpdateReleaseNoteSchema>;

// Delete
export const DeleteReleaseNoteSchema = t.type({
    id: t.number
});
export type DeleteReleaseNote = t.TypeOf<typeof DeleteReleaseNoteSchema>;

// Get
export const GetReleaseNotesSchema = t.partial({
    published_only: t.boolean,
    limit: t.number,
    unseen_only: t.boolean
});
export type GetReleaseNotes = t.TypeOf<typeof GetReleaseNotesSchema>;

// Mark as seen
export const MarkReleaseNoteAsSeenSchema = t.type({
    release_note_id: t.number
});
export type MarkReleaseNoteAsSeen = t.TypeOf<typeof MarkReleaseNoteAsSeenSchema>;

// User release note seen record
export const UserReleaseNoteSeenRecordSchema = t.type({
    id: t.number,
    doc_id: t.string,
    release_note_id: t.number,
    seen_at: timestampCodec
});
export type UserReleaseNoteSeenRecord = t.TypeOf<typeof UserReleaseNoteSeenRecordSchema>;

// Client API
export const ReleaseNoteApis = {
    ReleaseNotes: {
        Create: {
            Name: 'admin-createReleaseNote',
            Request: CreateReleaseNoteSchema,
            Response: t.intersection([t.type({data: ReleaseNoteRecordSchema}), CallResponseSchema])
        },
        Update: {
            Name: 'admin-updateReleaseNote',
            Request: UpdateReleaseNoteSchema,
            Response: t.intersection([t.type({data: ReleaseNoteRecordSchema}), CallResponseSchema])
        },
        Delete: {
            Name: 'admin-deleteReleaseNote',
            Request: DeleteReleaseNoteSchema,
            Response: CallResponseSchema
        },
        Get: {
            Name: 'admin-getReleaseNotes',
            Request: GetReleaseNotesSchema, 
            Response: t.intersection([t.type({data: t.array(ReleaseNoteRecordSchema)}), CallResponseSchema])
        },
        MarkAsSeen: {
            Name: 'users-markReleaseNoteAsSeen',
            Request: MarkReleaseNoteAsSeenSchema,
            Response: CallResponseSchema
        }
    }
}
